/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Geosciences18Inputs */

const en__field__enum_primarystudyinterest_study_geosciences18 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Geosciences18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geosciences`)
};

const de__field__enum_primarystudyinterest_study_geosciences18 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Geosciences18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geowissenschaften`)
};

/**
* | output |
* | --- |
* | "Geosciences" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Geosciences18Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_geosciences18 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Geosciences18Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Geosciences18Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_geosciences18(inputs)
	return de__field__enum_primarystudyinterest_study_geosciences18(inputs)
});
export { _field__enum_primarystudyinterest_study_geosciences18 as "_field__enum_primaryStudyInterest_STUDY_GEOSCIENCES" }